import { render, staticRenderFns } from "./UserViewModal.vue?vue&type=template&id=d5cb87ae"
import script from "./UserViewModal.vue?vue&type=script&lang=js"
export * from "./UserViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports